import React, { useState, useEffect } from "react";
import "../styles/DigitalMarketing.css";
import { useNavigate } from "react-router-dom";
import ContactPage from "./ContactPage";
import { motion } from "framer-motion";

const DigitalMarketing = () => {
  const [visibleRows, setVisibleRows] = useState({});
  const [activeIndex, setActiveIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  const navigate = useNavigate();
  const handleClicked = () => {
    navigate("/contact");
  };
  const handleToggle = (id) => {
    setVisibleRows((prev) => ({
      ...prev,
      [id]: !prev[id]
    }));
  };
  const features = [
    {
      img: "/images/image 26.webp",
      bgImg: "/images/bg1.webp",
      title: "SEO (Search Engine Optimization)",
      description:
        "We focus on enhancing your site’s visibility through strategic keyword research and on - page optimization."
    },
    {
      img: "/images/image 27.webp",
      bgImg: "/images/bg2.webp",
      title: "SMO (Social Media Optimization)",
      description:
        "We optimize your social media page’s and show your branding presence across various platforms."
    },
    {
      img: "/images/image 28.webp",
      bgImg: "/images/bg3.webp",
      title: "SMM (Social Media Marketing)",
      description:
        "Enhance a result with our digital marketing strategies through targeting a right audience using ad campaigns on Facebook and Instagram platforms."
    },
    {
      img: "/images/image 29.webp",
      bgImg: "/images/bg4.webp",
      title: "PPC (Pay-Per-Click Advertising)",
      description:
        "We specialize in PPC campaign that we drive targeted audience to your site."
    },
    {
      img: "/images/image 30.webp",
      bgImg: "/images/bg5.webp",
      title: "Brand Performance",
      description:
        "We are a trusted digital marketing agency and best in driving a result on seo and smm."
    },
    {
      img: "/images/image 31.webp",
      bgImg: "/images/bg6.webp",
      title: "Offline Capabilities",
      description:
        "We create a comprehensive marketing strategy that engages customers both in the online and offline."
    }
  ];
  const features1 = [
    {
      img: "/images/image 133.webp",
      bgImg: "/images/bg1.webp",
      title: "Understanding Your Business Needs",
      description:
        "Before we start, we deep dive into your business your goals, target audience, competitors, and challenges. We analyze your industry, market trends, and existing digital presence to identify opportunities for growth."
    },
    {
      img: "/images/image 103.webp",
      bgImg: "/images/bg2.webp",
      title: "Customized Strategy Development",
      description:
        "Once we understand your business, we craft a tailored digital marketing strategy designed to get you the best return on investment (ROI). This could include multiple digital marketing strategies that work flawlessly with your business."
    },
    {
      img: "/images/image 134.webp",
      bgImg: "/images/bg3.webp",
      title: "Website and SEO Optimization",
      description:
        "Your website is of utmost priority, we make sure it’s optimized for both users and search engines. Our team improves speed, optimizes landing pages, and fixes all SEO issues to attract more visitors and converting them into customers."
    },
    {
      img: "/images/image 135.webp",
      bgImg: "/images/bg4.webp",
      title: "Content and Social Media Marketing",
      description:
        "Once the SEO roadmap is laid, we create engaging, valuable content to connect with your audience and boost brand awareness. Our content is proven to build trust and add value to your website."
    },
    {
      img: "/images/image 136.webp",
      bgImg: "/images/bg4.webp",
      title: "Data-Driven Refinement",
      description:
        "Marketing is not done in one sitting, it’s continuous optimization. We track, analyze, and refine every campaign for better performance. This data driven approach ensures consistent growth and improved ROI."
    }
  ];
  const developmentTypes = [
    { title: "Search engine optimization", icon: "/images/image 127.webp" },
    { title: "Pay per click (PPC)", icon: "/images/image 128.webp" },
    { title: "Social Media Marketing", icon: "/images/image 129.webp" },
    { title: "Google my business (GMB)", icon: "/images/image 130.webp" },
    { title: "Content marketing", icon: "/images/image 131.webp" },
    { title: "Branding", icon: "/images/image 132.webp" }
  ];
  const data = [
    {
      id: 1,
      title: "What is digital marketing?",
      content:
        "Digital marketing refers to the use of digital channels, platforms, and technologies to promote and advertise products or services. It involves reaching and engaging customers online."
    },
    {
      id: 2,
      title: "What are the advantages of Digital marketing services ? ",
      content:
        "Digital marketing services offer cost-effectiveness, global reach, targeted audience engagement, measurable results, real-time interaction, and improved ROI for businesses."
    },
    {
      id: 3,
      title:
        "How cost-effective is digital marketing compared to traditional marketing?",
      content:
        "Digital marketing is more cost-effective than traditional marketing, offering targeted reach, measurable results, and lower costs for higher ROI."
    }
  ];
  return (
    <>
      <section className="digitalsection">
        <div className="digitalsection1">
          <motion.h2
            className="digitalsection2"
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
          >
            Digital Marketing Company in Salem
          </motion.h2>
          <motion.p
            className="fsp digitalsection3"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8, ease: "easeOut" }}
          >
            More leads, more sales & more growth – Scale your business with
            MPeoples!
          </motion.p>
          <motion.button
            className="uiuxbutton"
            onClick={handleClicked}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 1, duration: 0.5 }}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Let's talk &#8594;
          </motion.button>
        </div>
      </section>
      <section className="m d-none d-md-flex flex-column justify-content-center align-items-center">
        <h2 className="fsh2 m0 mb2">Services</h2>
        <h3 className="fsh3 m0 mb2">Digital marketing services we offer</h3>
        <div className="container9">
          {developmentTypes.map((service, index) => (
            <div className="service2-card" key={index}>
              <div className="icon2">
                <img src={service.icon} alt="" />
              </div>
              <h3 className="icon2h3">{service.title}</h3>
            </div>
          ))}
        </div>
      </section>
      <section className="mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-start text-md-center d-flex flex-column align-items-left align-items-md-center justify-content-center mb2">
          <h2 className="fsh2 m0 mb2">Process</h2>
          <p className="fsh3 m0 mb2">Our Top Rated Digital Marketing Process</p>
        </div>
        <div className="row g-4 w-100">
          {features1.map((feature, index) => (
            <div key={index} className="col-md-10 col-lg-6">
              <div
                className="card shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2box"
                style={{ border: "2px solid #137eb1" }}
              >
                <div
                  className="d-flex justify-content-between justify-content-md-center align-items-center w-100"
                  onClick={() => isMobile && toggleAccordion(index)}
                  style={{ cursor: isMobile ? "pointer" : "default" }}
                >
                  <div className="d-flex flex-md-column align-items-center justify-content-center gap-3">
                    <div className="section2img">
                      <img
                        src={feature.img}
                        alt={feature.title}
                        className="card-img-top img-fluid"
                      />
                    </div>
                    <h5 className="fsh4">{feature.title}</h5>
                  </div>
                  <div>
                    {isMobile && (
                      <span className="fs-4">
                        {activeIndex === index ? "−" : "+"}
                      </span>
                    )}
                  </div>
                </div>
                <div
                  className={`card-body ${isMobile ? "accordion-content" : ""}`}
                  style={{
                    display: isMobile
                      ? activeIndex === index
                        ? "block"
                        : "none"
                      : "block",
                    transition: "all 0.3s ease"
                  }}
                >
                  {/* <h5 className="fsh4">{feature.title}</h5> */}
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
          <div
            className="col-md-10 col-lg-6 d-flex flex-column justify-content-center 
 align-items-center"
          >
            <div className=" digtrans">
              <h2 className="mb-4" style={{ color: "white" }}>
                Start Your Digital Transformation With Us
              </h2>
              <button
                onClick={handleClicked}
                className="btn px-4 py-2"
                style={{
                  backgroundColor: "white",
                  color: "#137eb1"
                }}
              >
                Connect With Us
              </button>
            </div>
          </div>
        </div>
      </section>
      {/*SECTION 4*/}
      <section className="m d-flex justify-content-center align-items-center">
        <div className="builder">
          <div className="builderimage">
            <img
              src={"/images/guy.webp"}
              alt=""
              style={{
                height: "236px",
                marginBottom: "32px",
                textShadow: "2px 2px 4px #000000"
              }}
            />
          </div>
          <div className="buiderimage1">
            <h2 className="fsh3" style={{ color: "white" }}>
              Better discussions, better decisions
            </h2>
            <p className="fsp" style={{ color: "#FBBC04" }}>
              We are for everyone - Startups, SMBs, Enterprises. Connect with us
              for a conversation.
            </p>
            <button className="button" style={{ textAlign: "right" }}>
              <span className="text2">
                <a
                  style={{ color: "white", textDecoration: "none" }}
                  href="/contact"
                >
                  Speak to us &rarr;
                </a>
              </span>
              <div className="circle2"></div>
            </button>
          </div>
        </div>
      </section>
      <section className="m">
        <div className="offersdiv">
          <div className="d-flex flex-column gap-4">
            <div>
              <h2 className="tl fsh2 m0 mb2">Why we are the best!</h2>
              <h4 className="offersh4 fsh3 m0 mb2">
                We Offer a Full Range of <br /> Digital Marketing Services!
              </h4>
            </div>
            <div className="dm">
              <div className="d-flex flex-row align-items-center tl dm1">
                <div>
                  <img
                    style={{ width: "12px", height: "9px" }}
                    src="/images/tick1.webp"
                    alt=""
                  />
                </div>
                <div>
                  <p className="digidm1p fsp">
                    We specialize in both planning and executions
                  </p>
                </div>
              </div>
              <div className="d-flex flex-row align-items-center tl dm1">
                <div>
                  <img
                    style={{ width: "12px", height: "9px" }}
                    src="/images/tick1.webp"
                    alt=""
                  />
                </div>
                <div>
                  <p className="digidm1p fsp">
                    Our Seo expert team will enhance your site visibility by
                    using keyword research strategies.{" "}
                  </p>
                </div>
              </div>
              <div className="d-flex flex-row align-items-center tl dm1">
                <div>
                  <img
                    style={{ width: "12px", height: "9px" }}
                    src="/images/tick1.webp"
                    alt=""
                  />
                </div>
                <div>
                  <p className="digidm1p fsp">
                    We create trust among your audience by the presence of a
                    brand on all social media platforms.
                  </p>
                </div>
              </div>
              <div className="d-flex flex-row align-items-center tl dm1">
                <div>
                  <img
                    style={{ width: "12px", height: "9px" }}
                    src="/images/tick1.webp"
                    alt=""
                  />
                </div>
                <div>
                  <p className="digidm1p fsp">
                    Targeting the right audience for your business to enhance
                    your leads by using PPC campaign.
                  </p>
                </div>
              </div>
            </div>
            <div style={{ textAlign: "left" }}>
              <button className="button" onClick={handleClicked}>
                GET A QUOTE &rarr;
              </button>
            </div>
          </div>
          <div>
            <img className="offersimg" src="/images/offers1.webp" alt="" />
          </div>
        </div>
      </section>
      <ContactPage />
      {/* <section className="section1">
        <div>
          <div className="serviceclass1">
            <img src="/images/background.webp" alt="" />
          </div>
          <div className="serviceclass2">
            <h4 className="fsh2 mb2 serviceclass2h4">Leading Digital Marketing Company in Salem</h4>
            <p className="fsp webservicep col-10">
            Our digital marketing solutions that enhance companies marketing goals. Our strategies are in line with the latest trends in online marketing.
            </p>
            <button
              className="button"
              style={{ textAlign: "right" }}
              onClick={handleClicked}
            >
              <span className="text">Let's Talk &rarr;</span>
              <div className="circle"></div>
            </button>
          </div>
        </div>
      </section> */}

      {/* <section className="m d-flex justify-content-center">
        <div className="sec2sub1 col-10">
          <h4 className="fsh2 m0 mb2 ">
            How Digital Marketing Drive Business Growth :
          </h4>
          <p className="degsec2p fsp m0 mb2">
            Digital marketing drives growth by targeting the right audiences,
            boosting online visibility and driving conversions.
          </p>
        </div>
      </section> */}
      {/* <section className="digimar m">
        <h4 className="digimarrh4 fsh2 m0 mb2">
          Our digital marketing approach
        </h4>
        <div className="mainalign">
          <div className="parentalign">
            <img src="/images/107.webp" alt="" className="childalign" />
            <h1 className="childalignh1dig fsh4">Onboarding Kickoff</h1>
            <p className="childp fsp">
              Our Onboarding Kickoff process ensures a smooth start to your
              digital marketing journey. We align strategies, set clear goals
              and drive impactful results by driven campaigns.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/106.webp" alt="" className="childalign" />
            <h1 className="childalignh1dig fsh4">Website Planning</h1>
            <p className="childp fsp">
              It involves identifying the business objective and formulating a
              strategy that reflects your corporate image and validates your
              product/service offerings to the targeted customers.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/105.webp" alt="" className="childalign" />
            <h1 className="childalignh1dig fsh4">Strategy Development :</h1>
            <p className="childp fsp">
              Our Strategy Development focuses on analyzing your business goals,
              target audience, and market trends. our SEO strategies enhance
              rankings, organic traffic and boost conversions effectively.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/104.webp" alt="" className="childalign" />
            <h1 className="childalignh1dig fsh4">Reporting & Communication</h1>
            <p className="childp fsp">
              Our Reporting & Communication ensures transparency and alignment.
              We provide detailed performance reports, actionable insights, and
              regular updates to keep you informed, helping optimize strategies
              and achieve your digital marketing goals.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/103.webp" alt="" className="childalign" />
            <h1 className="childalignh1dig fsh4">
              Ongoing Support & Relationship Building{" "}
            </h1>
            <p className="childp fsp">
              We focus on continuous optimization and personalized assistance.
              We collaborate closely with you, adapting strategies to ensure
              growth and long-term success in your journey.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/102.webp" alt="" className="childalign" />
            <h1 className="childalignh1dig fsh4">Access & Asset Collection </h1>
            <p className="childp fsp">
              We gather necessary assets such as branding materials, content and
              account access to build a strong foundation for success.
            </p>
          </div>
          <div className="parentalign">
            <img src="/images/101.webp" alt="" className="childalign" />
            <h1 className="childalignh1dig fsh4">Implementation </h1>
            <p className="childp fsp">
              Focuses on executing tailored strategies across channels. From
              launching campaigns to optimizing content, we ensure seamless
              integration of tactics, driving results and achieving your
              business objectives effectively.
            </p>
          </div>
          <div className="parentaligned">
            <div className="backgound">
              <h1 className="childalignh1dig fsh4">
                Start your digital transformation with us
              </h1>
              <button className="buttin">
                <a
                  style={{
                    textDecoration: "none",
                    color: "#137eb1",
                    fontWeight: "400",
                    fontSize: "16px"
                  }}
                  href="/contact"
                >
                  Connect with us
                </a>
              </button>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="interestingfactdig m">
        <div className="interestingfacts">
          <div className="interestingfacts1">
            <h2 className="interestingfactsh fsh4">
              Interesting Facts And Figures Of Our Success
            </h2>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 41.webp" alt="" className="ifimages" />
            <h2 className="fsh4">250+</h2>
            <p>Projects</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 42.webp" alt="" className="ifimages" />
            <h2 className="fsh4">50+</h2>
            <p>Satisfied Clients</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 43.webp" alt="" className="ifimages" />
            <h2 className="fsh4">6+</h2>
            <p>Industry Experience</p>
          </div>
          <div className="interestingfacts1">
            <img src="/images/image 44.webp" alt="" className="ifimages" />
            <h2 className="fsh4">20+</h2>
            <p>Developement People</p>
          </div>
        </div>
      </section> */}

      {/* <section className="m">
        <div className="realdig">
          <div className="real1 d-flex align-items-md-center align-items-start justify-content-md-center justify-content-start text-md-center text-start">
            <h2 className="reelh2 fsh2 mo mb2">
              Our <span style={{ color: "black" }}>Commitment</span>
            </h2>
            <p className="reelh2pdig fsp m0 mb2 col-10">
              We deliver exceptional results through personalized strategies,
              constant optimization, and transparent communication. We focus on
              driving growth, maximizing ROI, and ensuring long-term success for
              your brand.
            </p>
          </div>
          <div className="real2 d-flex justify-content-md-around justify-content-start align-items-md-center align-items-start">
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real1.webp" alt="" className="realimg" />
              <h2 className="realh2 fsh4">Complete Transparency</h2>
              <p className="realp fsp">
                We communicate each and everything across the teams and work and
                eventually collaborate with each other to complete the task at
                the right time with proper manners.
              </p>
            </div>
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real2.webp" alt="" className="realimg" />
              <h2 className="realh2 fsh4">Timely Delivery</h2>
              <p className="realp fsp">
                We have specific goals and timeline, that is what we are doing
                that should complete on time. Our entire team will follow these
                goals and deliver the project on time efficiently.
              </p>
            </div>
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real3.webp" alt="" className="realimg" />
              <h2 className="realh2 fsh4">30-Day Support</h2>
              <p className="realp fsp">
                We ensure that we provide 30 days free support for you to
                coordinate until project submission.
              </p>
            </div>
            <div className="real3 d-flex align-items-start align-items-md-center">
              <img src="/images/real4.webp" alt="" className="realimg" />
              <h2 className="realh2 fsh4">24/7 Assistance</h2>
              <p className="realp fsp">
                It ensures round-the-clock support, addressing any project needs
                or issues promptly to keep your goals on track.
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* <section className="m">
        <div className="opt">
          <div className="opt1">
            <h4 className="opt1h4 fsh3 m0 mb2">SEO OPTIMIZATION</h4>
            <h2 className="opt1h2 fsh2 mo mb2">
              Our <span style={{ color: "black" }}> Website Ranking </span> at
              the Top
            </h2>
          </div>
          <div className="opt2"></div>
        </div>
      </section> */}

      {/* <section className="m d-flex justify-content-md-center justify-content-start">
        <div className="col-10">
          <div className="percet">
            <div className="percet1">
              <h2 className="percet1h2 m0 mb2">1st</h2>
              <p className="percet1p fsp m0 mb2">
                position at google for our target keywords
              </p>
            </div>
            <div className="percet1">
              <h2 className="percet1h2 fsh3 m0 mb2">100%</h2>
              <p className="percet1p fsp m0 mb2">
                Our site’s organic traffic increased.
              </p>
            </div>
          </div>
          <div className="percet2 text-start text-md-center">
            <h2 className="percet2h2 fsh2 m0 mb2">
              Our Social Media{" "}
              <span style={{ color: "black" }}> Strategy </span> in Action
            </h2>
            <p className="percet2p fsp m0 mb2">
              Our Product “makkalnaatkaati” social media pages consistently
              reach and engage with relevant content, connecting with our <br />
              audience through valuable insights and updates.
            </p>
          </div>
          <div className="percet3">
            <h2 className="percet3h2 fsh3 m0 mb2">Makkalnaatkaati</h2>
            <div className="percetsub mb2">
              <div className="percet3image">
                <img className="percet3img" src="/images/ig.webp" alt="" />
                <h1 className="percet3h1 fsh3">2.5L Reach</h1>
              </div>
              <div>
                <img className="percet3img" src="/images/fbk.webp" alt="" />
                <h1 className="percet3h1 fsh3">1.9L Reach</h1>
              </div>
            </div>
          </div>
          <div className="percet4">
            <div className="percet4sub1 d-flex flex-column justify-content-md-center justify-content-start align-items-md-center align-items-start">
              <h2 className="percet4sub1h2 fsh3 m0 mb2"> Facebook Meta ads</h2>
              <p className="percet4sub1p fsp m0 mb2">
                We attract clients through targeted Meta ads, reaching the right
                audience with our strategic approach to get the best client. 
                Image for meta ads
              </p>
            </div>
            <div className="percet4sub1">
              <h2 className="percet4sub1h2 fsh3 m0 mb2">
                Truly engaged subscribers
              </h2>
              <p className="percet4sub1p fsp m0 mb2">
                Our “Makkalnaatkaati” YouTube channel attracts truly engaged
                subscribers, offering valuable content that connects with our
                audience. We focus on building a community of loyal viewers who
                truly enjoy and support our videos.
              </p>
            </div>
            <div className="percet5 d-flex flex-column justify-content-md-center justify-content-start align-items-md-center align-items-start">
              <div className="percet5sub1">
                <div className="percet5rnd m0 mb2"></div>
                <div className="percet5rnd1 fsh3 m0 mb2">
                  1.35K Subscribers.
                </div>
              </div>
              <div className="percet5sub1">
                <div className="percet5rnd m0 mb2"></div>
                <div className="percet5rnd1 fsh3 m0 mb2">With images.</div>
              </div>
            </div>
          </div>
        </div>
      </section> */}
      {/*SECTION 3*/}
      {/* <section className="mainsec2 d-flex flex-column justify-content-center align-items-center m">
        <div className="text-center d-flex flex-column align-items-center -justify-content-center">
          <h2 className="fsh2 m0 mb2">Connecting Users and Business</h2>
        </div>

        <div className="row g-4 ">
          {features.map((feature, index) => (
            <div key={index} className="col-md-6 col-lg-4 ">
              <div className="card border-0 shadow-sm p-3 h-100 d-flex flex-column justify-content-center align-items-center section2img section2box">
                <img
                  src={feature.img}
                  alt={feature.title}
                  className="card-img-top img-fluid"
                />
                <div className="card-body">
                  <h5 className="fsh4">{feature.title}</h5>
                  <p className="fsp">{feature.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section> */}
    </>
  );
};
export default DigitalMarketing;